import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Translate, I18n } from 'react-redux-i18n';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import classNames from 'classnames';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT, BACKGROUND_COLOR, APP_COLORS } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { toFromDates } from '../Common/cleanDates';
import FilterByStart from '../Common/filterByStart';
import FilterMultiKeyword from '../Common/filterMultiKeyword';
import { SelectionWithProps } from '../Common/selection';
import { DETAILED_INVENTORIES_URL } from '../../actions/url';
import { numberWithCommas } from '../Common/numberWithCommas';
import checkPermission from '../Common/permissions';
import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';

//import {buttonStyle} from '../Common/style'

const isMyuMyu = ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" || ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";

momentLocalizer(moment);

class RowRenderer extends Component {

    setScrollLeft(scrollBy) {
        // To freeze couple columns
        this.refs.row.setScrollLeft(scrollBy);
    }

    getRowStyle() {
        return {
            color: this.getRowBackground()
        }
    }


    getRowBackground() {
      return this.props.row.InStock > 0 ? 'black' : BACKGROUND_COLOR.OutofStock
    }

    render() {
        //here we are just changing the style
        //but we could replace this with anything we liked, cards, images, etc
        //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
        return (<div style={this.getRowStyle()}  ><ReactDataGrid.Row ref='row' {...this.props} /></div>)
    }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func
};

class Inventories extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.inventoriesPage,

            rows: [],
            selectedRows: [],
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
            gourpOpen: false,
            currentGroup: null,
            currentCategory: null,
            groupExpanded: false,
            clear: true,
            renderRows: true,
            totalInventoryPrice: 0,
        };

        this.handleResize = this.handleResize.bind(this);
        // this.zoneLevel = this.zoneLevel.bind(this);
        this.inventoryDetail = this.inventoryDetail.bind(this);
    }

    componentWillMount() {
      this.props.setValue('inventories', 'typeRadios', 'All');
      this.props.setValue('inventories', 'periodRadios', '7');
      this.props.resetGroupAndCategory();
      this.props.fetchWarehouses();
    }

    componentDidMount() {
        // window.addEventListener('resize', this.handleResize);
        this.props.fetchGroups();
        // this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));

        let currentCategoryGroup = this.props.currentCategoryGroup;
        let typeRadios = 'All';
        let fromDate = '1900-01-01';
        let toDate = '3000-01-01';
        if(currentCategoryGroup) {
          typeRadios = currentCategoryGroup.typeRadios || typeRadios;
          fromDate = currentCategoryGroup.fromDate || fromDate;
          toDate = currentCategoryGroup.toDate || toDate;
        }
        if(currentCategoryGroup && currentCategoryGroup.currentRows && currentCategoryGroup.currentRows.length != 0) {
          let selectedRows =[];
          let newInventories = currentCategoryGroup.currentRows;
          if(this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
            newInventories.map(inventory => {
              if(inventory.Product_id == this.props.currentCategoryGroup.currentProduct_id) {
                inventory.isSelected = true;
                selectedRows.push(inventory);
              }
            })
          }
          this.setState({
              rows: newInventories,
              selectedRows: selectedRows,
              renderRows: false
          });
          if(selectedRows.length != 0)
            this.props.setGroupCategory({currentRows: newInventories});
        }
        if(currentCategoryGroup && currentCategoryGroup.currentGroup) {
          if(currentCategoryGroup.currentGroup != -1)
            this.props.fetchGroupCategories(currentCategoryGroup.currentGroup);
          this.setState({
            currentGroup: currentCategoryGroup.currentGroup,
            currentCategory: currentCategoryGroup.currentCategory,
            groupExpanded: true
          })
        }
        if(typeRadios == '-1') {
          this.props.setValue('inventories', 'FromDate', fromDate);
          this.props.setValue('inventories', 'ToDate', toDate);
        }
        else {
          this.props.setValue('inventories', 'periodRadios', '7');
        }
        // setTimeout(() => {this.props.setValue('inventories', 'typeRadios', typeRadios)}, 1000);
        this.props.setValue('inventories', 'typeRadios', typeRadios);
    }

    // routerWillLeave(nextLocation) {
    //   this.props.resetGroupAndCategory();
    // }

    componentDidUpdate(prevProps, prevState) {
        let productGroup_id = this.state.currentGroup;
        let productCategory_id = this.state.currentCategory;
        var groups = document.getElementsByName('group');
        let i = 0;
        for(; i < groups.length; i++) {
          if(groups[i].id != 'g'+productGroup_id){
            groups[i].style.backgroundColor = null;
          }
          else {
            groups[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
          }
        }
        var categories = document.getElementsByName('category');
        i = 0;
        if(categories) {
          for(; i < categories.length; i++) {
            if(categories[i].id != 'c'+productCategory_id){
              categories[i].style.backgroundColor = null;
            }
            else{
              categories[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
            }
          }
        }
        if (Data.Selectors.getRows(prevState) !== Data.Selectors.getRows(this.state)) {
          let totalInventoryPrice = 0;
          const inventories = Data.Selectors.getRows(this.state);
          inventories.forEach((inventory) => {
            totalInventoryPrice += inventory.InventoryPrice;
          });
          this.setState({
            totalInventoryPrice,
          });
        }
    }

    componentWillUnmount() {
        if(this.state.clear)
          this.props.setGroupCategory(null);
        this.props.setOriginPage('inventories')
        this.props.resetWarehouses();
        // window.removeEventListener('resize', this.handleResize);
    }

    // Once inventories is ready, reset state.

    componentWillReceiveProps(nextProps) {
        if(nextProps.product && nextProps.product != this.props.product) {
          let index = _.findIndex(this.state.rows, {Product_id: nextProps.product});
          this.state.rows.map(r => r.isSelected = false)
          if(index > -1) {
            this.state.rows[index].isSelected = true;
            this.setState({selectedRows: [this.state.rows[index]]})
          }
          else {
            this.setState({selectedRows: []})
          }
        }
        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
            let newInventories = [...nextProps.inventories];
            let selectedRows =[];
            if(newInventories.length != 0 && this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
              newInventories.map(inventory => {
                if(inventory.Product_id == this.props.currentCategoryGroup.currentProduct_id) {
                  inventory.isSelected = true;
                  selectedRows.push(inventory);
                }
              })
            }
            if(selectedRows.length != 0)
              this.props.setGroupCategory(null);
            this.setState({
                rows: newInventories,
                selectedRows: selectedRows
            });
        }

        if (nextProps.groups && nextProps.groups != this.props.groups) {
          let productGroup_id = nextProps.groups[0].ProductGroup_id;
          const { fromDate: f, toDate: t, periodRadios } = this.props;
          const { fromDate, toDate } = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t });
          const warehouse = this.getWarehouseQueryLine();

          if(this.state.currentCategory == -1 && this.state.currentGroup == -1) {
            if(this.props.typeRadios)
              this.props.fetchInventoriesByPeriod(this.props.typeRadios, '', fromDate, toDate, warehouse);
          }
          else if(this.state.currentCategory && this.state.currentCategory != -1) {
            if(this.props.typeRadios)
              this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate, warehouse);
          }
          else if(this.state.currentGroup && this.state.currentGroup != -1) {
            if(this.props.typeRadios)
              this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, fromDate, toDate, warehouse);
          }
          else {
            // this.props.fetchInventoriesByGroup(productGroup_id);
            if(this.props.typeRadios)
              this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + productGroup_id, fromDate, toDate, warehouse);
            this.setState({currentGroup: productGroup_id})
          }
        }

        // if (nextProps.inventoriesByGroup && nextProps.inventoriesByGroup != this.props.inventoriesByGroup) {
        //     let newInventories = [...nextProps.inventoriesByGroup];
        //     let selectedRows =[];
        //     if(newInventories.length != 0 && this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
        //
        //       newInventories.map(inventory => {
        //         if(inventory.Product_id == this.props.currentCategoryGroup.currentProduct_id) {
        //           inventory.isSelected = true;
        //           selectedRows.push(inventory);
        //         }
        //       })
        //     }
        //     if(selectedRows.length != 0)
        //       this.props.setGroupCategory(null);
        //     this.setState({
        //         rows: newInventories,
        //         selectedRows: selectedRows
        //     });
        //
        // }
        // if (nextProps.inventoriesByCategory && nextProps.inventoriesByCategory != this.props.inventoriesByCategory) {
        //     let newInventories = [...nextProps.inventoriesByCategory];
        //     let selectedRows =[];
        //     if(newInventories.length != 0 && this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
        //       newInventories.map(inventory => {
        //         if(inventory.Product_id == this.props.currentCategoryGroup.currentProduct_id) {
        //           inventory.isSelected = true;
        //           selectedRows.push(inventory);
        //         }
        //       })
        //     }
        //     if(selectedRows.length != 0)
        //       this.props.setGroupCategory(null);
        //     this.setState({
        //         rows: newInventories,
        //         selectedRows: selectedRows
        //     });
        // }

        if (nextProps.fromDate && nextProps.fromDate != this.props.fromDate) {
          if (nextProps.fromDate !== '') {
            const { fromDate: f } = nextProps;
            const { fromDate, toDate } = this.getFormattedDates({ fromDate: f, toDate: this.props.toDate });
            const warehouse = this.getWarehouseQueryLine();

            console.log('====================', fromDate);
            console.log('====================', toDate);
            this.props.setValue('inventories', 'periodRadios', '-1');
            // this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate);

            if(this.state.currentCategory == -1 && this.state.currentGroup == -1) {
              if(nextProps.typeRadios)
                this.props.fetchInventoriesByPeriod(nextProps.typeRadios, '', fromDate, toDate, warehouse);
            }
            else if(this.state.currentCategory && this.state.currentCategory != -1) {
              if(nextProps.typeRadios)
                this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate, warehouse);
            }
            else if(this.state.currentGroup && this.state.currentGroup != -1) {
              if(nextProps.typeRadios)
                this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, fromDate, toDate, warehouse);
            }
          }
        }

        if (nextProps.toDate && nextProps.toDate != this.props.toDate) {
          if (nextProps.toDate !== '') {
            const { toDate: t } = nextProps;
            const { fromDate, toDate } = this.getFormattedDates({ toDate: t, fromDate: this.props.fromDate });
            const warehouse = this.getWarehouseQueryLine();
            this.props.setValue('inventories', 'periodRadios', '-1')
            // this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate);

            if(this.state.currentCategory == -1 && this.state.currentGroup == -1) {
              if(nextProps.typeRadios)
                this.props.fetchInventoriesByPeriod(nextProps.typeRadios, '', fromDate, toDate, warehouse);
            }
            else if(this.state.currentCategory && this.state.currentCategory != -1) {
              if(nextProps.typeRadios)
                this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate, warehouse);
            }
            else if(this.state.currentGroup && this.state.currentGroup != -1) {
              if(nextProps.typeRadios)
                this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, fromDate, toDate, warehouse);
            }
          }
        }

        if (nextProps.typeRadios && nextProps.typeRadios != this.props.typeRadios) {
          // if (nextProps.typeRadios == 'All' && this.props.typeRadios == null) return;
          const { fromDate: f, toDate: t } = this.props;
          const { periodRadios } = nextProps;
          const { fromDate, toDate } = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t });
          // periodRadios = `/${periodRadios}`;
          const warehouse = this.getWarehouseQueryLine();

          // if(nextProps.periodRadios == '-1')
          //   periodRadios = '';
          if (this.state.currentCategory && this.state.currentCategory != -1) {
              this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate, warehouse);
          }
          else if (this.state.currentGroup && this.state.currentGroup != -1) {
            this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, fromDate, toDate, warehouse);
          }
          else if (this.state.currentGroup == -1 && this.state.currentCategory == -1){
            this.props.fetchInventoriesByPeriod(nextProps.typeRadios, '', fromDate, toDate, warehouse);
          }
          // this.props.setValue('inventories', 'FromDate', '');
          // if (nextProps.typeRadios == 'InStock'
          // || nextProps.typeRadios == 'OutStock'
          // || nextProps.typeRadios == 'All'
          // || nextProps.typeRadios == 'NonZero') {
          //   if (this.state.currentCategory && this.state.currentCategory != -1) {
          //     this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate);
          //   }
          //   else if (this.state.currentGroup && this.state.currentGroup != -1) {
          //     this.props.fetchInventoriesByPeriod(nextProps.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, fromDate, toDate);
          //   }
          //   else if (this.state.currentGroup == -1 && this.state.currentCategory == -1){
          //       this.props.fetchAllInventories(nextProps.typeRadios);
          //   }
          // } else {
          //
          // }
        }

        if (nextProps.periodRadios && nextProps.periodRadios != this.props.periodRadios) {
          const { fromDate: f, toDate: t } = this.props;
          const { periodRadios } = nextProps;
          const { fromDate, toDate } = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t });
          // periodRadios = `/${periodRadios}`;
          const warehouse = this.getWarehouseQueryLine();

          // if(nextProps.periodRadios == '-1')
          //   periodRadios = '';

          if (this.props.periodRadios == null) return
          if (nextProps.periodRadios != '-1') {
            this.props.setValue('inventories', 'FromDate', '');
            this.props.setValue('inventories', 'ToDate', '');
          }

          if (this.state.currentCategory && this.state.currentCategory != -1) {
            this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductCategory1_id=' + this.state.currentCategory, fromDate, toDate, warehouse);
          }
          else if (this.state.currentGroup && this.state.currentGroup != -1) {
            this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + this.state.currentGroup, fromDate, toDate, warehouse);
          }
          else if (this.state.currentGroup == -1 && this.state.currentCategory == -1){
            this.props.fetchInventoriesByPeriod(this.props.typeRadios, '', fromDate, toDate, warehouse);
          }
        }

        if (nextProps.inventoriesByPeriod && nextProps.inventoriesByPeriod != this.props.inventoriesByPeriod) {
          let newInventories = [...nextProps.inventoriesByPeriod];
          if(this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentRows) {
            this.props.setGroupCategory(null);
            this.setState({renderRows: true})
          }
          else {
            let selectedRows =[];
            if(newInventories.length != 0 && this.props.currentCategoryGroup && this.props.currentCategoryGroup.currentProduct_id) {
              newInventories.map(inventory => {
                if(inventory.Product_id == this.props.currentCategoryGroup.currentProduct_id) {
                  inventory.isSelected = true;
                  selectedRows.push(inventory);
                }
              })
            }
            this.setState({
                rows: newInventories,
                selectedRows: selectedRows
            });
            this.props.setGroupCategory(null);
          }
        }

        if (this.props.warehouseList !== nextProps.warehouseList) {
          const { warehouseList } = nextProps;
          warehouseList.map(warehouse => {
            if (warehouse.IsDefault) {
              const defaultWarehouse = { value: warehouse.Warehouse_id, label: warehouse.Name };
              this.props.setValue('inventories', 'Warehouse', defaultWarehouse);
            }
          })
        }

        // if (nextProps.nonZeroInventories && nextProps.nonZeroInventories != this.props.nonZeroInventories) {
        //   console.log('nonzero inventories received');
        //   let newInventories = [...nextProps.nonZeroInventories];
        //   this.setState({
        //       rows: newInventories,
        //   });
        // }
    }

    getFormattedDates(dates) {
      let { fromDate, toDate } = dates;
      if (!fromDate) {
        fromDate = '2016-01-01';
      } else {
        fromDate = moment(fromDate).format('YYYY-MM-DD');
      }
      if (!toDate) {
        toDate = '3000-01-01';
      } else {
        toDate = moment(toDate).format('YYYY-MM-DD');
      }
      return { fromDate, toDate };
    }

    getFormattedDatesFromPeriod(period, dates) {
      let { fromDate, toDate } = this.getFormattedDates(dates);
      if (period && period !== '-1') {
        toDate = moment().format('YYYY-MM-DD');
        if (period === '1') {
          fromDate = toDate;
        } else if (period === '2') {
          toDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
          fromDate = toDate;
        } else {
          fromDate = moment().subtract(parseFloat(period) - 1, 'days').format('YYYY-MM-DD');
        }
      }
      // console.log(period, dates, { fromDate, toDate });
      return { fromDate, toDate };
    }

    getWarehouseQueryLine() {
      let { warehouse } = this.props;
      if (!warehouse || warehouse.value === -1) {
        warehouse = '';
      } else {
        warehouse = `Warehouse_id=${warehouse.value}`;
      }
      return warehouse;
    }

    getWarehouseQueryLineByID(id) {
      let warehouse = '';
      if (!id || id === -1) {
        warehouse = '';
      } else {
        warehouse = `Warehouse_id=${id}`;
      }
      return warehouse;
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton });
    }

    // Set inventories being selected to be currentInventory and navigate user to the edit page
    // test

    setCurrentInventory(e) {
        e.preventDefault();
        const currentInventory = this.state.selectedRows[0];
        this.props.selectInventory(currentInventory);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentInventory();
    }

    // zoneLevel() {
    //   // e.preventDefault();
    //   console.log('arguments', arguments);
    //   this.setState({clear: false});
    //   const currentInventory = arguments[0];
    //
    //   let fromDate = this.props.fromDate;
    //   let toDate = this.props.toDate;
    //   if (fromDate == null) {
    //     fromDate = '1900-01-01';
    //   }
    //   if (toDate == null) {
    //     toDate = '3000-01-01';
    //   }
    //
    //   this.props.resetCurrentInventory();
    //   this.props.selectProduct(currentInventory);
    //   let currentRows = [];
    //   let colKey = Object.getOwnPropertyNames(this.state.filters)[0];
    //   if(colKey) {
    //     let filterMethod = this.state.filters[colKey] && this.state.filters[colKey].column.filterRenderer && this.state.filters[colKey].column.filterRenderer.name;
    //     this.state.rows.map(row => {
    //       let r = row[colKey].toString().toLowerCase();
    //       let term = this.state.filters[colKey].filterTerm.toString().toLowerCase()
    //       let index = (r).indexOf(term)
    //       if(filterMethod && index == 0) {
    //         currentRows.push(row);
    //       }
    //       else if (!filterMethod && index > -1) {
    //         currentRows.push(row);
    //       }
    //     })
    //   }
    //   else {
    //     currentRows = this.state.rows;
    //   }
    //   currentRows.map(r => {
    //     r.isSelected = false;
    //   })
    //   this.props.setGroupCategory({
    //     currentGroup: this.state.currentGroup,
    //     currentCategory: this.state.currentCategory,
    //     currentProduct_id: currentInventory.Product_id,
    //     typeRadios: this.props.typeRadios,
    //     fromDate: fromDate,
    //     toDate: toDate,
    //     currentRows: currentRows
    //   });
    //   // this.context.router.push('/inventories/detail/');
    //   this.context.router.push('/products/'+currentInventory.Product_id);
    // }

    inventoryDetail() {
      // e.preventDefault();
      this.setState({clear: false});
      const currentInventory = arguments[0];
      console.log("what is args", arguments);

      let fromDate = this.props.fromDate;
      let toDate = this.props.toDate;
      if (fromDate == null) {
        fromDate = '1900-01-01';
      }
      if (toDate == null) {
        toDate = '3000-01-01';
      }

      this.props.resetCurrentInventory();
      if(arguments[1] == 'productDetail') {
        this.props.selectProduct(currentInventory);
      }
      else {
        this.props.selectInventory(currentInventory);
      }
      // let currentRows = [];
      // let colKey = Object.getOwnPropertyNames(this.state.filters)[0];
      let currentRows = Data.Selectors.getRows(this.state);
      // if(colKey) {
      //   let filterMethod = this.state.filters[colKey] && this.state.filters[colKey].column.filterRenderer && this.state.filters[colKey].column.filterRenderer.name;
      //   this.state.rows.map(row => {
      //     let r = row[colKey].toString().toLowerCase();
      //     let term = this.state.filters[colKey].filterTerm.toString().toLowerCase()
      //     let index = (r).indexOf(term)
      //     if(filterMethod && index == 0) {
      //       currentRows.push(row);
      //     }
      //     else if (!filterMethod && index > -1) {
      //       currentRows.push(row);
      //     }
      //   })
      // }
      // else {
      //   currentRows = this.state.rows;
      // }
      currentRows.map(r => {
        r.isSelected = false;
      })
      this.props.setGroupCategory({
        currentGroup: this.state.currentGroup,
        currentCategory: this.state.currentCategory,
        currentProduct_id: currentInventory.Product_id,
        typeRadios: this.props.typeRadios,
        fromDate: fromDate,
        toDate: toDate,
        currentRows: currentRows
      });

      if(arguments[1] == 'productDetail') {
        this.context.router.push('/products/'+currentInventory.Product_id);
      }
      else {
        this.context.router.push('/inventories/detail/');
      }
      // this.context.router.push('/products/'+currentInventory.Product_id);
    }

    getWarehouseList() {
      const { warehouseList } = this.props;
      const options = [{ value: -1, label: 'All' }];
      warehouseList.map(warehouse => {
        options.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
      });
      return options;
    }

    fetchInventoriesByWarehouse = (id) => {
      const { fromDate: f, toDate: t, typeRadios } = this.props;
      const { periodRadios } = this.props;
      const { fromDate, toDate } = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t });

      // id not undefined means warehouse dropdown updated
      let warehouse = '';
      if (!id) {
        warehouse = this.getWarehouseQueryLine();
      } else {
        warehouse = this.getWarehouseQueryLineByID(id);
      }
      const { currentCategory, currentGroup } = this.state;
      let division = '';
      if (currentCategory && currentCategory !== -1) {
        division = `ProductNum__ProductCategory1_id=${currentCategory}`;
      } else if (currentGroup && currentGroup !== -1) {
        division = `ProductNum__ProductGroup_id=${currentGroup}`;
      }
      this.props.fetchInventoriesByPeriod(typeRadios, division, fromDate, toDate, warehouse);
    }

    handleWarehouseOnChange = (event) => {
      if (event) {
        this.fetchInventoriesByWarehouse(event.value);
      }
    }

    pushInventoryAdjustment(e) {
      e.preventDefault();
      this.context.router.push('/inventories/adjustment');
    }

    pushInventoryRelocation(e) {
      e.preventDefault();
      this.context.router.push('inventories/relocation');
    }

    fetchLowStockInventory(e) {
      e.preventDefault();
      this.context.router.push('/inventories/lowStock/');
    }

    fetchExpiredInventory(e) {
      e.preventDefault();
      this.context.router.push('/inventories/expired/');
    }
    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
      const { isLoading, inventoriesByGroupIsLoading, inventoriesByCategoryIsLoading, inventoriesByPeriodIsLoading } = this.props;
        if (isLoading || inventoriesByGroupIsLoading || inventoriesByCategoryIsLoading || inventoriesByPeriodIsLoading) return <Spinner/>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the row select function

            const onRowSelect = rows => {
                this.setState(...this.state, { selectedRows: rows });
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                this.setState({rows: this.props.inventoriesByPeriod})
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            const getValidFilterValues = (columnId) => {
              let values = this.state.rows.map(r => r[columnId]);
              return values.filter((item, i, a) => {
                return i === a.indexOf(item);
              });
            }

            const onClearFilters = () => {
                     //all filters removed
                     this.setState({ filters: {}, rows: this.props.inventoriesByPeriod });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let rows = this.state.rows.slice(0);
                let editedRows = this.state.editedRows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Product_id === rows[e.rowIdx].Product_id)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className='label label-success'><Translate value="enabled" /></span>;
                    else return <span className='label label-danger'><Translate value="disable" /></span>;
                }
            })

            const ProdNumFormatter = React.createClass({
                  render() {
                    return (
                      <span 
                        onDoubleClick={() => {
                          if (checkPermission('change_product')) {
                            this.props.zoneLevel(this.props.dependentValues, 'productDetail')
                          } else {
                            alert(I18n.t('msg_no_permission'));
                          }
                        }}
                      >
                        <span style={{color:'#585858'}}>{this.props.value.slice(0, 2)}</span>
                        <span style={{color:'#0B609F'}}>{this.props.value.slice(2, 4)}</span>
                        <span style={{color:'black'}}>{this.props.value.slice(4, 7)}</span>
                        <span style={{color:'black'}}>{this.props.value.slice(7)}</span>
                      </span>
                    );
                  }
            })

            ProdNumFormatter.PropTypes = {
              onDoubleClick: React.PropTypes.func
            };

            const DoubleClickFormatter = React.createClass({
                  PropTypes: {
                    onDoubleClick: React.PropTypes.func
                  },
                  render() {
                    let value;
                    if (this.props.value || this.props.value === 0) {
                      if(this.props.price) {
                        value = `$${numberWithCommas((this.props.value || 0).toFixed(2))}`;
                      } else {
                        value = this.props.value;
                      }
                    }
                    return (
                      <span 
                        onDoubleClick={() => {
                          if (checkPermission('change_inventory')) {
                            this.props.zoneLevel(this.props.dependentValues);
                          } else {
                            alert(I18n.t('msg_no_permission'));
                          }
                        }}
                      >
                        { value }
                      </span>
                    );
                  }
            });

            const ProductIsStopSaleBackGroundFormatter = ({ children, ...props }) => {
              const getRowBackground = () => {
                if (props.dependentValues.IsStopSale) {
                  return BACKGROUND_COLOR.tintedPink;
                }
              }
              return (
                <div style={{ backgroundColor: getRowBackground() }}>
                  {
                    React.cloneElement(children, props)
                  }
                </div>
              );
            };

            const TotalWeightFormatter = React.createClass({
              render() {
                const { ProductType } = this.props.dependentValues;
                const shouldShowValue = ProductType === 'Non-Fixed' ||
                                        ProductType === 'Per-Pound';
                const value = !shouldShowValue ? '' : this.props.value;
                return (
                  <div>
                    <span 
                      onDoubleClick={() => {
                        if (checkPermission('change_inventory')) {
                          this.props.zoneLevel(this.props.dependentValues);
                        } else {
                          alert(I18n.t('msg_no_permission'));
                        } 
                      }}
                    >
                      <span>{ value }</span>
                    </span>
                  </div>
                );
              }
            });


            const onRowsSelected = (rows) => {
                 let newRows = [...this.state.rows];
                 let selectedRows = this.state.selectedRows;

                 newRows.map(r => {
                   r.isSelected = false;
                 })

                 selectedRows = [];
                 rows.map(row => {
                   let index = _.findIndex(this.state.rows, {'ProductNum': row.row.ProductNum})
                   newRows[index].isSelected = true;
                   selectedRows.push(row);
                 });

                 this.setState({rows: newRows, selectedRows: selectedRows});
            }

            const onRowsDeselected = (rows) => {
                 let newRows = [...this.state.rows];
                 rows.map (row => {
                   let index = _.findIndex(this.state.rows, {'ProductNum': row.row.ProductNum})
                   newRows[index].isSelected = false;
                 });
                 let selectedRows = [];
                 newRows.map(r => {
                   if(r.isSelected)
                    selectedRows.push(r);
                 })
                 this.setState({rows: newRows, selectedRows: selectedRows});
            }

            // Discontinued Product Background Color Formatter
            const DiscontinuedProductCellBackGroundFormatter = (props) => {
              const rowBackground = props.dependentValues.IsDiscontinued
                ? BACKGROUND_COLOR.lightGray
                : '';
              return (
                <div style={{ backgroundColor: rowBackground }}>
                  <span>{ props.value }</span>
                </div>
              );
            }

            // Column difinition

            const columns = [
              {
                  key: 'ProductNum',
                  name: <Translate value="prod_num" />,
                  resizable: true,
                  sortable: true,
                  width: 70,
                  filterable: true,
                  filterRenderer: FilterByStart,
                  formatter:
                    <ProductIsStopSaleBackGroundFormatter> 
                      <ProdNumFormatter zoneLevel={this.inventoryDetail}/>
                    </ProductIsStopSaleBackGroundFormatter>,
                  getRowMetaData: (row) => row
              },
              {
                key: 'GeneralNum',
                name: <Translate value={isMyuMyu?"index_no":"general_no"} />,
                resizable: true,
                sortable: true,
                width: 80,
                filterable: true,
                filterRenderer: FilterByStart,
                formatter: DiscontinuedProductCellBackGroundFormatter,
                getRowMetaData: row => row,
              },
              {
                  key: 'RefNum',
                  name: <Translate value="ref_num" />,
                  resizable: true,
                  sortable: true,
                  width: 70,
                  filterable: true,
                  filterRenderer: FilterByStart,
                  formatter:
                    <ProductIsStopSaleBackGroundFormatter> 
                      <DoubleClickFormatter zoneLevel={this.inventoryDetail}/>
                    </ProductIsStopSaleBackGroundFormatter>,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'Name',
                  name: <Translate value="product_name" />,
                  resizable: true,
                  sortable: true,
                  width: 250,
                  filterable: true,
                  filterRenderer: FilterMultiKeyword,
                  formatter:
                    <ProductIsStopSaleBackGroundFormatter> 
                      <DoubleClickFormatter zoneLevel={this.inventoryDetail}/>
                    </ProductIsStopSaleBackGroundFormatter>,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'Description',
                  name: <Translate value="description" />,
                  resizable: true,
                  sortable: true,
                  width: 130,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail}/>,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'PackageType',
                  name: <Translate value="pkg_type" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail}/>,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'PackageSize',
                  name: <Translate value="package_size" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail}/>,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'TotalWeight',
                  name: <Translate value="total_wt" />,
                  resizable: true,
                  sortable: true,
                  width: 70,
                  filterable: true,
                  formatter: <TotalWeightFormatter zoneLevel={this.inventoryDetail} />,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'ProductType',
                  name: <Translate value="prod_type" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} />,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'PriceLv5',
                  name: <Translate value="sale_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 60,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} price={true}/>,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'InStock',
                  name: <Translate value="stock" />,
                  resizable: true,
                  sortable: true,
                  width: 60,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail}/>,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'PreSale',
                  name: <Translate value="presale" />,
                  resizable: true,
                  sortable: true,
                  width: 75,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail}/>,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'Purchased',
                  name: <Translate value="purchased" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail}/>,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'InventoryPrice',
                  name: <div><Translate value="inventory_price" /><span className="asteriksReq">*</span></div>,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} price />,
                  getRowMetaData: (row) => row
              },
              {
                  key: 'Buyer',
                  name: <Translate value="purchaser" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail}/>,
                  getRowMetaData: (row) => row
              },
            ];

            // Dynamically add warehouse columns with instock level
            const { warehouseList, warehouse } = this.props;
            if (warehouseList && warehouse) {
              if (warehouse.value && warehouse.value === -1) {
                columns.push({
                  key: 'Markup',
                  name: <Translate value="avg_markup_percentsign" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} />,
                  getRowMetaData: row => row,
                });
                warehouseList.map(item => {
                  columns.push({
                    key: `Warehouse_${item.Warehouse_id}`,
                    name: item.Name,
                    resizable: true,
                    sortable: true,
                    width: 130,
                    filterable: true,
                    formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} />,
                    getRowMetaData: (row) => row
                  });
                });
              } else if (warehouse.value && warehouse.value !== -1) {
                // columns.push({
                //   // key: 'Default_WarehouseZone_Name',
                //   key: 'Zone', // fake zone, will need to change back to Default_WarehouseZone_Name
                //   name: <Translate value="zone" />,
                //   resizable: true,
                //   sortable: true,
                //   width: 60,
                //   filterable: true,
                //   formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} />,
                //   getRowMetaData: (row) => row
                // });
                // columns.push({
                //   // key: 'Default_WarehouseBin_Name',
                //   key: 'Bin', // fake Bin, will need to change back to Default_WarehouseBin_Name
                //   name: <Translate value="bin" />,
                //   resizable: true,
                //   sortable: true,
                //   width: 60,
                //   filterable: true,
                //   formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} />,
                //   getRowMetaData: (row) => row
                // });
                columns.push({
                  // key: 'Default_WarehouseBin_Name',
                  key: 'Location', // fake Bin, will need to change back to Default_WarehouseBin_Name
                  name: <Translate value="location" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
                  formatter: <DoubleClickFormatter zoneLevel={this.inventoryDetail} />,
                  getRowMetaData: (row) => row
                });
              }
            }

            return (
              //React Table Inventory List
              <div className='react-table-customizer' id='react_table_inventory'>
                <ReactDataGrid
                    rowRenderer={
                      <RowRenderer 
                        onDoubleClick={(data) => {
                          if (checkPermission('change_inventory')) {
                            this.inventoryDetail(data);
                          } else {
                            alert(I18n.t('msg_no_permission'));
                          }
                        }} 
                      />
                    }
                    rowKey='id'
                    enableCellSelect={true}
                    rowHeight={25}
                    headerRowHeight={45}
                    onGridSort={handleGridSort}
                    toolbar={<Toolbar enableFilter={true}/>}
                    onAddFilter={handleFilterChange}
                    getValidFilterValues={getValidFilterValues}
                    onClearFilters={onClearFilters}
                    columns={columns}
                    rowGetter={rowGetter}
                    rowsCount={getSize() }
                    minHeight={this.state.tableHeight}
                    enableRowSelect='single'
                    rowSelection={{
                      showCheckbox: true,
                      onRowsSelected: onRowsSelected,
                      onRowsDeselected: onRowsDeselected,
                      selectBy: {
                        isSelectedKey: 'isSelected'
                      }
                    }}
                />
              </div>
            )
        }
    }

    handleClickCategory(id) {
      const { fromDate: f, toDate: t } = this.props;
      let { periodRadios } = this.props;
      const { fromDate, toDate } = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t });
      const warehouse = this.getWarehouseQueryLine();
      // periodRadios = '/' + this.props.periodRadios;
      // if(this.props.periodRadios == '-1')
      //   periodRadios = '';
      this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductCategory1_id=' + id, fromDate, toDate, warehouse);
      this.setState({currentCategory: id});
    }

    renderCategories(group_id) {
      if(!this.props.groupCategories)  return;
      let groupCategories = this.props.groupCategories;
      let description;
      if(localStorage.getItem('lang') == 'ch') {
        description = 'Description'
      }
      else if(localStorage.getItem('lang') == 'en') {
        description = 'Name'
      }
      if(this.state.currentGroup == group_id && this.state.groupExpanded)
        return groupCategories.map( category => {
          return (
            <li className = 'clickListLi' style={{color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial'}} name='category' id={'c'+category.ProductCategory_id} onClick = {this.handleClickCategory.bind(this, category.ProductCategory_id)}>
              <label style={{fontWeight: 'bold'}}>{category.CategoryNum}</label>{' ' + category[description]}
            </li>
          )
        })
      else
        return;
    }

    handleClickGroup(group, id) {
      let groupExpanded = this.state.groupExpanded;
      const { fromDate: f, toDate: t } = this.props;
      let { periodRadios } = this.props;
      const { fromDate, toDate } = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t });
      const warehouse = this.getWarehouseQueryLine();
      // periodRadios = '/' + this.props.periodRadios;
      // if(this.props.periodRadios == '-1')
      //   periodRadios = '';
      if(group && this.state.currentGroup == group.ProductGroup_id) {
        this.setState({groupExpanded: !groupExpanded});
        if(!groupExpanded) {
          this.setState({currentCategory: -1})
          this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + group.ProductGroup_id, fromDate, toDate, warehouse);
          this.props.fetchGroupCategories(group.ProductGroup_id);
        }
      }
      else if(group) {
        this.setState({currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1});
        this.props.fetchInventoriesByPeriod(this.props.typeRadios, 'ProductNum__ProductGroup_id=' + group.ProductGroup_id, fromDate, toDate, warehouse);
        this.props.fetchGroupCategories(group.ProductGroup_id);
      }
      else {
        this.setState({currentGroup: -1, currentCategory: -1});
        this.props.fetchInventoriesByPeriod(this.props.typeRadios, '', fromDate, toDate, warehouse);
      }
    }


    renderGroups() {
      if(!this.props.groups)  return;
      let groups = this.props.groups;
      return groups.map( (group) => {
        let GroupNum = parseInt(group.GroupNum);
        if (GroupNum < 10) GroupNum = '0' + GroupNum;
        let description;
        if(localStorage.getItem('lang') == 'ch') {
          description = 'Description'
        }
        else if(localStorage.getItem('lang') == 'en') {
          description = 'Name'
        }
        return (
          <Panel className='panelStyle' >
            <div style={{color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer'}} name='group' id={'g'+group.ProductGroup_id} onClick = {this.handleClickGroup.bind(this, group, 'g'+group.ProductGroup_id)}>
              <label style={{fontWeight: 'bold'}}>{GroupNum}</label> {' ' + group[description]}
            </div>
            {this.renderCategories(group.ProductGroup_id)}
          </Panel>
        )
      })
    }

    renderPeriods() {
      if (this.props.typeRadios == 'Inactive' || this.props.typeRadios == 'Active') {
        return (
          <Field name='periodRadios' component={renderPeriodRadios} typeRadios={this.props.typeRadios}/>
        )
      }
    }

    renderPrint() {
      let type = this.props.typeRadios;
      let division = '';
      if(this.state.currentCategory == -1 && this.state.currentGroup == -1) {
        division = '';
      } else if(this.state.currentCategory && this.state.currentCategory != -1) {
        division = 'ProductNum__ProductCategory1_id=' + this.state.currentCategory;
      } else if(this.state.currentGroup && this.state.currentGroup != -1) {
        division = 'ProductNum__ProductGroup_id=' + this.state.currentGroup;
      }

      const { fromDate: f, toDate: t } = this.props;
      const { periodRadios } = this.props;
      const { fromDate, toDate } = this.getFormattedDatesFromPeriod(periodRadios, { fromDate: f, toDate: t });
      const warehouse = this.getWarehouseQueryLine();
      const warehouseQuery = (warehouse !== '') ? `&${warehouse}` : '';
      // periodRadios = '';
      // if(this.props.periodRadios != '-1') {
      //   periodRadios = '/' + this.props.periodRadios;
      // }
      const dates = toFromDates(-1, fromDate, toDate);
      const token = localStorage.getItem('token');
      let url;
      if (type !== 'Inactive' && type !== 'Active') {
        if (division === '') {
          url = `${DETAILED_INVENTORIES_URL}${type}/export?Bearer=${token}${warehouseQuery}`;
        } else {
          url = `${DETAILED_INVENTORIES_URL}${type}/export?${division}${warehouseQuery}&Bearer=${token}`;
        }
      } else {
        if (division === '') {
          url = `${DETAILED_INVENTORIES_URL}${type}/export?startdate=${dates.fromDate}&enddate=${dates.toDate}${warehouseQuery}&Bearer=${token}`;
        } else {
          url = `${DETAILED_INVENTORIES_URL}${type}/export?${division}&startdate=${dates.fromDate}&enddate=${dates.toDate}${warehouseQuery}&Bearer=${token}`;
        }
      }
      return (
        <Button
          bsStyle='success'
          type='button'
          href={checkPermission('export_inventory') && url}
          onClick={(event) => {
            if (checkPermission('export_inventory')) {
              event.persist();
            } else {
              alert(I18n.t('msg_no_permission'));
            }
          }}
        >
          <em className='fa fa-download' />
          <Translate value="excel" />
        </Button>
      );
    }

    renderWarehouseList() {
      // If group is loading, show a spinner.
      if (this.props.warehouseListIsLoading && !this.props.fetchWarehousesError) {
        return <Spinner />;
      } else if (this.props.fetchWarehousesError) {
        return (
          <ContentWrapper>
            <div className='alert alert-danger'>
              <Translate value="warehouse_cannot_be_loaded" />
            </div>
          </ContentWrapper>
        );
      }
      const options = this.getWarehouseList();
      // console.log('renderWarehouseList', options, defaultWarehouse);
      return (
        <Field name='Warehouse' component={SelectionWithProps} options={options} onChange={this.handleWarehouseOnChange} />
      );
    }

    render() {
        return (
            //---------------
            // Begin HTML
            //---------------
            <ContentWrapper>

                {/* Nav Trail */}
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Translate value="warehouse_management" />
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active='true'>
                    <Translate value="inventory" />
                  </Breadcrumb.Item>
                </Breadcrumb> {/* End Nav Trail */}

                <Grid fluid='true' id='inventory-page'>
                  {/*<Row>
                    <div id='date-range-picker' className='form-horizontal'>
                      <Row>
                        <Col md={ 3 }>
                          <Field name='typeRadios' component={ renderTypeRadios } />
                        </Col>
                        <Col md={ 8 }>
                          { this.renderPeriods() }
                        </Col>
                        <Col md={ 1 } className='search-btn'>
                          <Button
                            bsStyle='primary'
                            type='submit' >
                           onClick={() =>{ this.fetchSalesOrdersByDetails(); }}>
                            <em className='fa fa-search' />
                            <Translate value=""/>
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Row>*/}
                  <Row>
                    <Col xs={12}>
                      <Panel id='date-range-picker' className='form-horizontal'>
                        <Row>
                          <Col xs={1}>
                            <h3 className='filter-title'><Translate value="inventory_condition" /><span className='colon'>:</span></h3>
                          </Col>
                          <Col xs={4}>
                            <Row>
                              <Col xs={12}>
                                <Field name='typeRadios' component={renderRedesignRadiosRowOne} />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <Field name='typeRadios' component={renderRedesignRadiosRowTwo} />
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={1}>
                            <h3 className='filter-title'><Translate value="order_date" /><span className='colon'>:</span></h3>
                          </Col>
                          <Col xs={5}>
                            <Row>
                              <Col xs={12}>
                                <Field name='periodRadios' component={renderRedesignDateRadiosOne} typeRadios={this.props.typeRadios}/>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <Field name='periodRadios' component={renderRedesignDateRadiosTwo} typeRadios={this.props.typeRadios} Days={this.props.periodRadios} />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Panel>
                    </Col>
                  </Row>
                  {/* Row Wrapper  */}
                  <Row>
                    {/* Product Category Nav */}
                    <Col sm={2} className='product-categories-nav'>
                      <Panel id='category-nav' className='panelStyle' style={{ maxHeight: (this.state.tableHeight+71), overflowY: 'scroll', width: '100%' }}>
                        <Panel className='panelStyle' >
                          <div style={{color: APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer'}} name='group' id='g-1' onClick = {this.handleClickGroup.bind(this, null, '-1')}>
                            <Translate value="all" />
                          </div>
                        </Panel>
                        {this.renderGroups()}
                      </Panel>
                    </Col> {/* End Product Category Nav */}

                    {/* Main Workspace */}
                    <Col sm={10}>


                      {/* Inventory Table */}
                      <Row>
                        <Col md={ 12 }>
                          <Panel className='position-relative' id='table-panel' >
                            <ButtonToolbar className='table-buttons'>
                              { /* <Button
                                 bsStyle='warning'
                                 type='button'
                                 onClick={this.fetchLowStockInventory.bind(this)} >
                                 <em className='fa fa-exclamation' />
                                <Translate value="low_stock" />
                              </Button>
                              <Button
                                 bsStyle='danger'
                                 type='button'
                                 onClick={this.fetchExpiredInventory.bind(this)} >
                                 <em className='fa fa-warning'/>
                                <Translate value="expiring" />
                              </Button> */}
                              {this.renderPrint()}
                            </ButtonToolbar>
                            <div className='table-filters' style={{ zIndex: 1 }}>
                              <label className='control-label'><Translate value="warehouse" /></label>
                              <div className='control-dropdown'>
                                { this.renderWarehouseList() }
                              </div>
                              <Col xs={4}>
                                <label className="total-inventory-price inventory-notes">
                                  <span className="total-inventory-price-label">
                                    <Translate value="total_inventory_price" />:&nbsp;
                                  </span>
                                  <span className="font-color-orange">
                                    { `$${numberWithCommas((this.state.totalInventoryPrice || 0).toFixed(2))}` }
                                  </span>
                                </label>
                              </Col>
                              <Col xs={3}>
                                <label className="inventory-notes">
                                  <span className="pull-right">
                                    <Translate value="msg_inventory_price_equation" />
                                  </span>
                                </label>
                              </Col>
                              { /* <ButtonToolbar>
                                <Button
                                  bsStyle='primary'
                                  className='search-btn'
                                  type='submit'
                                  onClick={this.fetchInventoriesByWarehouse}
                                >
                                  <em className='fa fa-search' />
                                </Button>
                              </ButtonToolbar> */ }
                            </div>
                            {/* Render Inventory Table  */}
                            <Row>
                              <Col sm={12}>
                                { this.renderTable() }
                              </Col>
                            </Row>
                          </Panel>
                        </Col>
                      </Row> {/* End Inventory Table */}

                    </Col> {/* End Main Workspace */}
                  </Row> {/* End Row Wrapper  */}
                </Grid>
            </ContentWrapper>
            //---------------
            // End HTML
            //---------------

        );
    }
}

let renderTypeRadios = props => {
    return (
      <div className='form-group col-md-12'>
        <Row>
          <label className='col-sm-4'>
            <input {...props.input} type='radio' value='All'
              checked={props.input.value === 'All'}/>
            <Translate value="all" />
          </label>
          <label className='col-sm-4'>
            <input {...props.input} type='radio' value='InStock'
              checked={props.input.value === 'InStock'}/>
            <Translate value="in_stock" />
          </label>
          <label className='col-sm-4'>
            <input {...props.input} type='radio' value='Inactive'
              checked={props.input.value === 'Inactive'}/>
            <Translate value="in_stock_inactive" />
          </label>
        </Row>
        <Row>
          <label className='col-sm-4'>
            <input {...props.input} type='radio' value='NonZero'
              checked={props.input.value === 'NonZero'}/>
            <Translate value="non_zero" />
          </label>
          <label className='col-sm-4'>
            <input {...props.input} type='radio' value='OutStock'
              checked={props.input.value === 'OutStock'}/>
            <Translate value="out_of_stock" />
          </label>
          <label className='col-sm-4'>
            <input {...props.input} type='radio' value='Active'
              checked={props.input.value === 'Active'}/>
            <Translate value="out_of_stock_active" />
          </label>
        </Row>
      </div>
    )
}

let renderPeriodRadios = props => {
    const titleClass = classNames({ 'col-md-offset-1': props.typeRadios === 'Inactive' },
                                  { 'col-md-offset-1': props.typeRadios === 'Active' },
                                  'col-md-1')
    let renderDatePickers = (value) => {
      if(value === '-1')
        return (
          <div className='form-group date-picker-positioner'>
            <label className='col-md-1 from-label col-md-offset-4'><Translate value="from" /></label>
            <div className='col-md-1 control-date-picker'>
              <Field name='FromDate' component={ DatePicker }/>
            </div>
            <label className='col-md-1 to-label'><Translate value="to" /></label>
            <div className='col-md-1 control-date-picker'>
              <Field name='ToDate' component={ DatePicker }/>
            </div>
          </div>
        )
      else {
        return;
      }
    }
    return (
      <div>
        <Row>
          <div className='form-group'>
            <label className={titleClass}>
              <input {...props.input} type='radio' value='7'
                checked={props.input.value === '7'}/>
              7 <Translate value="days" />
            </label>
            <label className='col-md-1'>
              <input {...props.input} type='radio' value='30'
                checked={props.input.value === '30'}/>
              30 <Translate value="days" />
            </label>
            <label className='col-md-1'>
              <input {...props.input} type='radio' value='90'
                checked={props.input.value === '90'}/>
              90 <Translate value="days" />
            </label>
            <label className='col-md-1'>
              <input {...props.input} type='radio' value='-1'
                checked={props.input.value === '-1'}/>
              <Translate value="date_range" />
            </label>
          </div>
        </Row>

        {/* Date Pickers */}
        <Row>
          {renderDatePickers(props.input.value)}
        </Row>
      </div>
    )
}

const getBsStyle = (input, value)=>{
  return input == value ? 'success':'primary'
}

let renderRedesignRadiosRowOne = props => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
  return (
    <ButtonToolbar className='radio-filter-buttons'>
      <Button bsStyle={getBsStyle(props.input.value, 'All')}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input {...props.input} id='all-radio-filter' type='radio' name='statusFilterRadios' value='All' checked={props.input.value === 'All'}/>
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'InStock')}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input {...props.input} id='all-radio-filter' type='radio' name='statusFilterRadios' value='InStock' checked={props.input.value === 'InStock'}/>
            <Translate value="in_stock" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Inactive')} className='radio-button-long'>
        <div className='radio' style={{ width: '150px' }}>
          <label for='all-radio-filter'>
            <input {...props.input} id='all-radio-filter' type='radio' name='statusFilterRadios' value='Inactive' checked={props.input.value === 'Inactive'}/>
            <Translate value="in_stock_inactive" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  )
}

let renderRedesignRadiosRowTwo = props => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
  return (
    <ButtonToolbar className='radio-filter-buttons'>
      <Button bsStyle={getBsStyle(props.input.value, 'NonZero')}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input {...props.input} id='all-radio-filter' type='radio' name='statusFilterRadios' value='NonZero' checked={props.input.value === 'NonZero'}/>
            <Translate value="non_zero" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'OutStock')}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input {...props.input} id='all-radio-filter' type='radio' name='statusFilterRadios' value='OutStock' checked={props.input.value === 'OutStock'}/>
            <span style={{ left: '15px' }}><Translate value="out_of_stock" /></span>
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Active')} className='radio-button-long'>
        <div className='radio' style={{ width: '150px' }}>
          <label for='all-radio-filter'>
            <input {...props.input} id='all-radio-filter' type='radio' name='statusFilterRadios' value='Active' checked={props.input.value === 'Active'}/>
            <Translate value="out_of_stock_active" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  )
}

let renderRedesignDateRadiosOne = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
  const buttonShouldDisable = props.typeRadios !== 'Inactive' && props.typeRadios !== 'Active';
  return (
    <ButtonToolbar className='radio-filter-buttons'>
      <Button bsStyle={getBsStyle(props.input.value, '1')} disabled={buttonShouldDisable}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input
              {...props.input}
              id='all-radio-filter'
              type='radio'
              name='dateRangeFilterRadios'
              value='1'
              checked={props.input.value === '1'}
              disabled={buttonShouldDisable}
            />
            <Translate value="today" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '2')} disabled={buttonShouldDisable}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input
              {...props.input}
              id='all-radio-filter'
              type='radio'
              name='dateRangeFilterRadios'
              value='2'
              checked={props.input.value === '2'}
              disabled={buttonShouldDisable}
            />
            <Translate value="yesterday" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '7')} disabled={buttonShouldDisable}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input
              {...props.input}
              id='all-radio-filter'
              type='radio'
              name='dateRangeFilterRadios'
              value='7'
              checked={props.input.value === '7'}
              disabled={buttonShouldDisable}
            />
            7 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '30')} disabled={buttonShouldDisable}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input
              {...props.input}
              id='all-radio-filter'
              type='radio'
              name='dateRangeFilterRadios'
              value='30'
              checked={props.input.value === '30'}
              disabled={buttonShouldDisable}
            />
            30 <Translate value="days" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  );
};

let renderRedesignDateRadiosTwo = (props) => {
  console.log('props you are looking for', props)
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'col-xs-2');
  const buttonShouldDisable = props.typeRadios !== 'Inactive' && props.typeRadios !== 'Active';
  const renderStartDatePicker = (days) => {
    if(!buttonShouldDisable && days == -1) {
      return (
        <Button bsStyle='primary'>
          <Field name='FromDate' placeholder={'Start'} component={ DatePicker }/>
        </Button>
      )
    }
    return (
      <Button bsStyle='primary' disabled={buttonShouldDisable}>
        <Field name='FromDate' placeholder={'Start'} component={ DisabledDatePicker }/>
      </Button>
    );
  }
  const renderEndDatePicker = (days) => {
    if(!buttonShouldDisable && days == -1) {
      return (
        <Button bsStyle='primary'>
          <Field name='ToDate' placeholder={'End'} component={ DatePicker }/>
        </Button>
      )
    }
    return (
      <Button bsStyle='primary' disabled={buttonShouldDisable}>
        <Field name='ToDate' placeholder={'End'} component={ DisabledDatePicker }/>
      </Button>
    );
  }

  return (
    <ButtonToolbar className='radio-filter-buttons'>
      <Button bsStyle={getBsStyle(props.input.value, '-1')} disabled={buttonShouldDisable}>
          <div className='radio'>
            <label for='dateRange-radio-filter'>
            <input
              {...props.input}
              id='dateRange-radio-filter'
              type='radio'
              name='dateFilterRadios'
              value='-1'
              checked={props.input.value === '-1'}
              disabled={buttonShouldDisable}
            />
             <Translate value="date_range" />
          </label>
        </div>
      </Button>
      {renderStartDatePicker(props.Days)}
      {renderEndDatePicker(props.Days)}
      {/* <Button
        bsStyle='primary'
        className='search-btn'
        type='submit'
        onClick={() =>{ props.fetchSalesOrdersByDetails(); }}>
        <em className='fa fa-search' />
      </Button> */}
    </ButtonToolbar>
  );
}

export default Inventories;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventories.jsx